
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			isScrolling: false,
			lastScrollTime: new Date()
		};
	},
	props: {
		speed: {
			type: Number,
			default: 5
		}
	},
	methods: {
		scrollTo(top:number) {
			this.isScrolling = true;
			this.lastScrollTime = new Date();
			requestAnimationFrame(() => {
				this.scrollFrame(top);
			});
		},

		scrollFrame(targetTop:number) {
			let currentTime = new Date();
			let dt = currentTime.getTime() - this.lastScrollTime.getTime();
			this.lastScrollTime = currentTime;

			let el = this.$el.parentElement;
			if (!el) {
				return;
			}
			let scrollPositionTop = el.scrollTop;

			if (targetTop < scrollPositionTop) {
				dt = -dt;
			}

			dt *= this.speed;

			let goingToTop = scrollPositionTop + dt;

			if (targetTop < scrollPositionTop) {
				if (goingToTop < targetTop) {
					goingToTop = targetTop;
				}
			} else if (goingToTop > targetTop) {
				goingToTop = targetTop;
			}

			el.scrollTo({top: goingToTop});
			if (goingToTop != targetTop) {
				requestAnimationFrame(() => this.scrollFrame(targetTop));
			} else {
				this.isScrolling = false;
			}
		},

		activate() {
			let top = (this.$el as HTMLElement).offsetTop;
			this.scrollTo(top);
		}
	},
});
